import Board2Container from "./Board2Container";

export default Board2Container;
